import React, { useEffect } from "react";
import Button from "../../components/button";
import Loader from "../../components/loader";
import PieceListSearchBar from "../../components/piece/pieceListWithSearchBar";
import PiecePreview from "../../components/piece/piecePreviews";
import { useDashboardContext } from "../../context/dashboardContext";
import { PieceResponseDTOMin } from "../../openapi-generated-client";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useNavigate } from "react-router-dom";

export default function DashboardMyPiecesPage() {

    const navigate = useSafeNavigate(useNavigate());

    const {appContext, sessionId} = useDashboardContext();
    const {pieceController} = appContext;

    const [data, setData] = React.useState<PieceResponseDTOMin[]|undefined>(undefined);
    const [needsProfile, setNeedsProfile] = React.useState<boolean>(false);

    async function fetchData() {
        try {
            setData((await pieceController.getOwnPieces(sessionId)).data);
        } catch(error: any) {
            if(error.status == 409) {
                setNeedsProfile(true);
            }else {
                window.location.href = "/error/1";
            }
        }
    }

    useEffect(() => {
        fetchData();
    }, []);


    if(data == undefined && needsProfile == false) return <Loader/>;

    if(needsProfile) {
        return <div className="inner-flex">
                <h2>Profile required</h2>
                <p>You did not yet fill out your name under 'profile'. This is required to upload your first piece.</p>
                <Button onClick={() => {
                    navigate("/dashboard/profile");
                }}>go to Profile</Button>
            </div>
    }

    return <PieceListSearchBar displayProps={{
        linkPrefix: "/dashboard/mypieces",
        hideComposer: true,
        hideIconDisplay: true,
        hideInfos: true,
        hideInstrumentation: true
    }} pieces={data || []}>
        <div className="piece-display" onClick={() => {
            window.location.href = "/dashboard/mypieces/create";
        }}>
            <PiecePreview fixedAspectRatio={10/12} placeholder thumbnailHash={""}/>
            <h2>Create new piece</h2>
        </div>
    </PieceListSearchBar>;
    }